<template>
  <div
    ref="canvas"
    class="base-echart"
    @mouseenter="pauseTooltipAutoplay"
    @mouseleave="resumeTooltipAutoplay"
  ></div>
</template>

<script>
import * as echarts from "echarts";
import { createTooltipAutoPlay } from "../../utils/echarts";

export default {
  name: "BaseEChart",
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    autoresize: {
      type: Boolean,
      default: true
    },
    tooltipAutoplay: {
      type: [Boolean, Object],
      default: false
    }
  },
  data() {
    return {
      chart: null,
      tooltipAutoplayController: null,
      isTooltipAutoplayPaused: false
    };
  },
  watch: {
    option(option) {
      this.setOption(option);
    },
    tooltipAutoplay: {
      handler() {
        this.restartTooltipAutoplay();
      },
      deep: true
    }
  },
  mounted() {
    this.initChart();
    if (this.autoresize) {
      window.addEventListener("resize", this.resizeChart);
    }
  },
  beforeDestroy() {
    if (this.autoresize) {
      window.removeEventListener("resize", this.resizeChart);
    }
    this.clearTooltipAutoplay();
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.canvas || this.chart) {
        return;
      }

      this.chart = echarts.init(this.$refs.canvas);
      this.setOption(this.option);
    },
    setOption(option) {
      if (!this.chart) {
        this.$nextTick(() => this.initChart());
        return;
      }

      this.chart.setOption(option || {}, true);
      this.ensureTooltipAutoplay();
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    ensureTooltipAutoplay() {
      if (
        !this.tooltipAutoplay ||
        this.tooltipAutoplayController ||
        !this.chart
      ) {
        return;
      }

      const settings = this.tooltipAutoplay === true ? {} : this.tooltipAutoplay;
      this.tooltipAutoplayController = createTooltipAutoPlay(this.chart, {
        ...settings,
        autoStart: !this.isTooltipAutoplayPaused
      });
    },
    clearTooltipAutoplay() {
      if (!this.tooltipAutoplayController) {
        return;
      }

      this.tooltipAutoplayController.stop();
      this.tooltipAutoplayController = null;
    },
    restartTooltipAutoplay() {
      this.clearTooltipAutoplay();
      this.ensureTooltipAutoplay();
    },
    pauseTooltipAutoplay() {
      this.isTooltipAutoplayPaused = true;
      if (this.tooltipAutoplayController) {
        this.tooltipAutoplayController.pause();
      }
    },
    resumeTooltipAutoplay() {
      this.isTooltipAutoplayPaused = false;
      if (this.tooltipAutoplayController) {
        this.tooltipAutoplayController.resume();
      }
    }
  }
};
</script>

<style scoped>
.base-echart {
  width: 100%;
  height: 100%;
}
</style>
